class Main {
    constructor() {
        console.log('main js class initialized')
        this.events()
    }

    events() {
        const menuSide = document.querySelector("#menu-side-menu .menu-item-has-children");
        if (menuSide !== null) {
            menuSide.addEventListener("mouseover", e => this.mouseOverSubMenuHandler(e))
            menuSide.addEventListener("mouseleave", e => this.mouseLeaveSubMenuHandler(e))
        }
        document.querySelector("#hamburger .openHamburger").addEventListener("click", e => this.openHamburgerHandler(e))
        document.querySelector("#hamburger .closeHamburger").addEventListener("click", e => this.closeHamburgerHandler(e))
        document.querySelector("#hamburgerMobile .openHamburger").addEventListener("click", e => this.openHamburgerHandler(e))
        document.querySelector("#hamburgerMobile .closeHamburger").addEventListener("click", e => this.closeHamburgerHandler(e))
        
        window.addEventListener("scroll", e => this.windowScrollHandler(e))
    }

    windowScrollHandler(e) {
        const header = document.querySelector("header")
        const stickyTop = window.scrollY;
        const mainMenu = document.querySelector('#main-menu')

        if (stickyTop > 50 && !mainMenu.classList.contains('open')) {
            header.classList.add('sticky');
        } else {
            if( header.classList.contains('sticky') ){
                header.classList.remove('sticky');
            }
        }
    }

    mouseOverSubMenuHandler(e) {
        const parentLi = e.target.closest('li')
        //console.log(parentLi, parentLi.classList.contains('menu-item-has-children'))
        if(parentLi.classList.contains('menu-item-has-children') === true) {
            parentLi.querySelector('.sub-menu').classList.add('open')
        }
    }

    mouseLeaveSubMenuHandler(e) {
        const parentLi = e.target.closest('li')
        if(parentLi.classList.contains('menu-item-has-children') === true) {
            parentLi.querySelector('.sub-menu').classList.remove('open')
        }
    }

    openHamburgerHandler(e) {
        const html = document.querySelector('html')
        const mainMenu = document.querySelector('#main-menu')
        const sideMenu = document.querySelector('.side_nav')
        const socialContactContainer_left = document.querySelector('#social_contact_container_left')
        const socialContactContainer_right = document.querySelector('#social_contact_container_right')
        const hamburgerIcon = document.querySelector('#hamburger .openHamburger')
        const hamburgerCloseIcon = document.querySelector('#hamburger .closeHamburger')
        const hamburgerIconMobile = document.querySelector('#hamburgerMobile .openHamburger')
        const hamburgerCloseIconMobile = document.querySelector('#hamburgerMobile .closeHamburger')
        const langIcon = document.querySelector('#lang_container')
        if(mainMenu.classList.contains('close')) {
            mainMenu.classList.remove('close')
        }
        mainMenu.classList.add('open')
        hamburgerCloseIcon.classList.add('open')
        hamburgerCloseIconMobile.classList.add('open')
        hamburgerIcon.classList.add('close')
        hamburgerIconMobile.classList.add('close')
        langIcon.classList.add('white')
        socialContactContainer_left.classList.add('white')
        socialContactContainer_right.classList.add('white')
        html.classList.add('bodySticky')

        setTimeout(() => {
            sideMenu.classList.add('opacity-0', 'pe-none')
        }, 750);
        
    }

    closeHamburgerHandler(e) {
        const html = document.querySelector('html')
        const mainMenu = document.querySelector('#main-menu')
        const sideMenu = document.querySelector('.side_nav')
        const socialContactContainer_left = document.querySelector('#social_contact_container_left')
        const socialContactContainer_right = document.querySelector('#social_contact_container_right')
        const hamburgerIcon = document.querySelector('#hamburger .openHamburger')
        const hamburgerCloseIcon = document.querySelector('#hamburger .closeHamburger')
        const hamburgerIconMobile = document.querySelector('#hamburgerMobile .openHamburger')
        const hamburgerCloseIconMobile = document.querySelector('#hamburgerMobile .closeHamburger')
        const langIcon = document.querySelector('#lang_container')
        mainMenu.classList.remove('open')
        mainMenu.classList.add('close')
        hamburgerCloseIcon.classList.remove('open')
        hamburgerCloseIconMobile.classList.remove('open')
        langIcon.classList.remove('white')
        socialContactContainer_left.classList.remove('white')
        socialContactContainer_right.classList.remove('white')
        html.classList.remove('bodySticky')

        setTimeout(() => {
            sideMenu.classList.remove('opacity-0', 'pe-none')
            hamburgerIcon.classList.remove('close')
            hamburgerIconMobile.classList.remove('close')
        }, 250);
        
    }
}

export default Main;